import { useQuery } from '@tanstack/react-query';
import supabase from '../utils/supabase';

export default function useNotes(folderId = null, taskListId = null) {
  return useQuery({
    queryKey: ['notes', folderId, taskListId],
    queryFn: async () => {
      let query = supabase.from('notes').select('*');

      if (folderId) {
        query = query.eq('folder_id', folderId);
      } else if (taskListId) {
        query = query.eq('task_list_id', taskListId);
      } else {
        query = query.is('folder_id', null).is('task_list_id', null);
      }

      const { data, error } = await query.order('created_at', {
        ascending: false,
      });
      if (error) throw error;
      return data;
    },
    enabled: true,
  });
}
